// import { ValidationItems, Widget } from '@kanda-libs/ks-component-ts';
// import { Button, Popover } from '@kanda-libs/ks-design-library';
// import DisabledEmailPopover from './DisabledEmailPopover';
// import { PROPS } from './constants';
// interface DisabledEmailFieldProps {
//   validation: object;
// }
// const DisabledEmailField = ({ validation }: DisabledEmailFieldProps) => (
// );
// export default DisabledEmailField;
import { ValidationItems, Widget } from '@kanda-libs/ks-component-ts';
import { Button, Popover } from '@kanda-libs/ks-design-library';

import DisabledEmailPopover from './DisabledEmailPopover';
import { PROPS } from './constants';

export interface DisabledEmailFieldProps {
  validation: ValidationItems;
}

const DisabledEmailField: React.FunctionComponent<DisabledEmailFieldProps> =
  function ({ validation }) {
    return (
      <div className="flex flex-col w-full">
        <label {...PROPS.emailLabel} htmlFor="customer_details.email">
          Email{' '}
          <Popover.Standard
            id="email-disabled"
            above
            button={
              <div className="w-4 h-4">
                <Button.Icon
                  id="change-email-button-checkout"
                  icon="info"
                  size="28-16"
                  className="-mt-1.5 -ml-1"
                />
              </div>
            }
          >
            {({ handleClose }) => (
              <DisabledEmailPopover onClose={handleClose} />
            )}
          </Popover.Standard>
        </label>
        <div className="cursor-not-allowed pointer-events-none relative">
          <Widget.CreditCustomerDetailsEmail
            {...PROPS.email}
            validation={validation as ValidationItems}
            disabled
          />
        </div>
      </div>
    );
  };

export default DisabledEmailField;
